import { ComponentInstall } from "../../utils";
import Input from "./src";

export default ComponentInstall(Input);
